import { addDoc, collection, serverTimestamp, Timestamp } from 'firebase/firestore'
import { auth, db } from '../firebase/config'

const APP_NAME = 'calc'
const TTL_DAYS = 30

let lastFingerprint = null
let lastTs = 0

const NOISE_PATTERNS = [
  /ResizeObserver loop/i,
  /Connection to Indexed Database server lost/i,
  /IndexedDB.*closing/i,
  /Failed to fetch/i,
  /NetworkError/i,
  /Load failed/i,
  /Network request failed/i,
  /webkit\.messageHandlers/i,
  /sendDataToNative/i,
]

function isNoise(message) {
  if (!message) return true
  return NOISE_PATTERNS.some((re) => re.test(message))
}

function fingerprint(kind, message) {
  return `${kind}::${(message || '').slice(0, 80)}`
}

async function reportError({ kind, message, stack = null }) {
  if (!message) return
  if (isNoise(message)) return
  const fp = fingerprint(kind, message)
  const now = Date.now()
  if (fp === lastFingerprint && now - lastTs < 5000) return
  lastFingerprint = fp
  lastTs = now

  const u = auth.currentUser
  const uid = u ? u.uid : 'anon'
  const email = u ? (u.email || '').toLowerCase() : ''
  try {
    await addDoc(collection(db, 'application_errors'), {
      uid,
      email,
      kind: String(kind || 'error').slice(0, 40),
      message: String(message).slice(0, 500),
      stack: stack ? String(stack).slice(0, 2000) : null,
      pathname: typeof location !== 'undefined' ? location.pathname : null,
      app: APP_NAME,
      ua: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 200) : null,
      ts: serverTimestamp(),
      expiresAt: Timestamp.fromMillis(now + TTL_DAYS * 24 * 3600 * 1000),
    })
  } catch (e) {
    if (import.meta.env.DEV) console.warn('[errors] failed to report', e?.code || e?.message)
  }
}

export function installErrorReporter() {
  if (typeof window === 'undefined') return
  window.addEventListener('error', (event) => {
    reportError({
      kind: 'window.error',
      message: event.message || String(event.error || 'unknown'),
      stack: event.error?.stack,
    })
  })
  window.addEventListener('unhandledrejection', (event) => {
    const r = event.reason
    reportError({
      kind: 'promise.rejection',
      message: r?.message || String(r || 'unhandled rejection'),
      stack: r?.stack,
    })
  })
}
